<script setup>
  import ListeArticles from '@/components/ListeArticles.vue'

</script>

<template>
  <h1>Liste des articles</h1>
  <div class="home">
    <ListeArticles/>
  </div>
</template>

<script>


export default {

}
</script>

<style>
 .logo {
width: 225px;
  padding: 20px;
  background: #fff;
  margin-bottom: -10px;
  box-shadow: 2px 2px 6px rgba(0,0,0,0.2);
  
 }
 @media screen and (max-width:992px) {
  .logo {
    margin-bottom: 35px;
  }
 }

</style>
